import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import Home from "../containers/Home/Home";
import About from "../containers/About/About";
import SportsPackages from "../containers/SportsPackages/SportsPackages";
import SportsPackagesDetails from "../containers/SportsPackages/SportsPackagesDetails";
import Contact from "../containers/Contact/Contact";

const Routes = ({ supportedLanguages }) => {
  // const getLanguage = localStorage.getItem("i18nextLng");
  // const language =
  //   supportedLanguages.find((lang) => lang === getLanguage) || "es";

  return (
    <>
      <Switch>
        <Route
          exact
          path={[ "/home", "/inicio", "/comeco"]}
          component={Home}
        />

        <Route
          exact
          path={[ "/institutional", "/institucional", "/institucional"]}
          component={About}
        />

        <Route
          exact
          path={[
            "/sports-packages",
            "/paquetes-deportivos",
            "/pacotes-de-esportes",
          ]}
          component={SportsPackages}
        />

        <Route
          exact
          path={[
            "/sports-packages-details/:name/:id",
            "/detalles-paquetes-deportivos/:name/:id",
            "/detalhes-pacotes-esportes/:name/:id",
          ]}
          component={SportsPackagesDetails}
        />

        <Route
          exact
          path={[
           
            "/contacto",
            "/contact",
            "/contato",
          ]}
          component={Contact}
        />

        {/* <Route
          exact
          path="/:lang/"
          render={(props) =>
            supportedLanguages.includes(props.match.params.lang) ? (
              <Home {...props} />
            ) : (
              <Redirect to={`/${language}/${props.match.params.lang}`} />
            )
          }
        /> */}

        <Route>
          <Redirect to={`/inicio`} />
        </Route>
      </Switch>
    </>
  );
};

export default Routes;
